import { useState } from 'react';
import { faqs } from '@/mocks/data';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            常见问题解答
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            汇集用户最常问的问题，帮助你快速解决疑惑
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="rounded-xl bg-background-50 border border-background-200/70 overflow-hidden transition-all duration-300"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
              >
                <span className="text-sm md:text-base font-medium text-foreground-900 pr-8">
                  {faq.question}
                </span>
                <div
                  className={`w-6 h-6 flex items-center justify-center rounded-full bg-secondary-100 flex-shrink-0 transition-transform duration-300 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                >
                  <i className="ri-arrow-down-s-line text-sm text-secondary-600" />
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 pb-5 px-5' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}